class TrendingProductBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.closeButton = this.querySelector('.trending-product-banner__close');
    this.currentVariantInput = document.querySelector('product-form').querySelector('[name="id"]');
    this.variantOptions = this.querySelector('#variant-popularity').children;
    this.variantPopularitySpan = document.getElementById('currentPopularity');
     
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.currentVariantInput.addEventListener('change', () => {
      this.getVariantPopularity();
      this.displayCurrentVariantPopularity();
    });

    this.getVariantPopularity();
    this.displayCurrentVariantPopularity();
  }

  getVariantPopularity() {
    const currentVariantId = this.currentVariantInput.value;

    for (const variant of this.variantOptions) {
      if (variant.dataset.variantId === currentVariantId) {
        this.currentPopularity = variant.dataset.variantPopularity;

        if(!variant.dataset.variantPopularity) {
          this.close();
          break;
        }

        this.show();
        break;
      }
    }
  }

  displayCurrentVariantPopularity() {    
    this.variantPopularitySpan.innerText = this.currentPopularity;
  }

  close() {
    this.classList.add('hidden');
  }

  show() {
    this.classList.remove('hidden');
  }
}

customElements.define('trending-product-banner', TrendingProductBanner);